import request from './request'
import { getUser } from '../utils/auth'

// 登录
export function login(account, password) {
  return request.post('login', { account, password })
}

// 培训列表
export function getTrainingList() {
  const user = getUser() || {}
  return request.post('xxtrainingList', {
    name: user.em_names,
    shenfen: user.shenfen,
    uid: user.id
  })
}

// 课程目录
export function getCourseList(id) {
  const user = getUser() || {}
  return request.post('xxsanjiList', {
    id,
    user: user.em_names,
    userId: user.id
  })
}

// 视频详情（含视频地址）
export function getVideoDetail(id) {
  return request.post('sanjiJilu', { id })
}

// 获取学习进度
export function getVideoProgress(listId, videoId) {
  const user = getUser() || {}
  return request.post('xxsanjiget', {
    listId,
    user: user.em_names,
    videoId
  })
}

// 保存学习进度
export function saveVideoProgress(listId, videoId, progress) {
  const user = getUser() || {}
  return request.post('xxsanjiSavesd', {
    listId,
    progress,
    uid: user.id,
    user: user.em_names,
    videoId
  })
}
